import type { Locale } from "../i18n";
import type { LocalizedText } from "../types";

/** Resolves bilingual content text for a locale, falling back to Russian. */
export function localize(text: LocalizedText, locale: Locale): string {
  return text[locale] || text.ru;
}
